/**
 * Created by Yoyo Fang on 09/12/2020
 * Description:
 *
 * ------ maintenance history ------
 */

import { Injectable, Type, ComponentRef } from '@angular/core';
import { NoteBodyComponent } from './note-body/note-body.component';
import { TextBoxComponent } from './text-box/text-box.component';
import { CheckBoxComponent } from './check-box/check-box.component';
import { DateComponent } from './date/date.component';
import { SingleDropdownComponent } from './single-dropdown/single-dropdown.component';
import { MultiSelectDropdownComponent } from './multi-select-dropdown/multi-select-dropdown.component';
import { EdDropdownComponent } from './ed-dropdown/ed-dropdown.component';
import { MultiEntityDropdownComponent } from './multi-entity-dropdown/multi-entity-dropdown.component';
import { ControlGroupComponent } from './control-group/control-group.component';
import { VirtualGroupComponent } from './virtual-group/virtual-group.component';
import { LabelControlComponent } from './label-control/label-control.component';
import { MdlComponent } from './mdl/mdl.component';
import { SeperatorComponent } from './seperator/seperator.component';
import { TemplateControlValue } from './../../../../../tamalelibs/src/app/models/template-control-value.model';
import { NameComponent } from './name/name.component';
import { ShortNameComponent } from './short-name/short-name.component';
import { SourceComponent } from './source/source.component';
import { SentimentComponent } from './sentiment/sentiment.component';
import { PriorityInputComponent } from './priority-input/priority-input.component';
import { TemplateControlConfig } from './template-control-config.model';
import { Subject, ReplaySubject } from 'rxjs';
import { NoteActions } from '../../tamalelibs/constants/business.constants';

@Injectable()
export class ComponentTypeMapper {
    private _map = {
        'name-input': NameComponent,
        'shortname-input': ShortNameComponent,
        'entity-input': MultiEntityDropdownComponent,
        'source-input': SourceComponent,
        'displaydate-input': DateComponent,
        'sentiment-input': SentimentComponent,
        'priority-input': PriorityInputComponent,
        'subject-input': TextBoxComponent,
        'ckeditor-input': NoteBodyComponent,
        'nb-input': NoteBodyComponent,
        'tb-input': TextBoxComponent,
        'date-input': DateComponent,
        'cb-input': CheckBoxComponent,
        'dd-input': SingleDropdownComponent,
        'msd-input': MultiSelectDropdownComponent,
        'ed-input': EdDropdownComponent,
        'met-input': MultiEntityDropdownComponent,
        'med-input': MultiEntityDropdownComponent,
        'group': ControlGroupComponent,
        'virtualgroup': VirtualGroupComponent,
        'label': LabelControlComponent,
        'mdl-input': MdlComponent,
        '': SeperatorComponent
    };

    private _defaultRequiredControlIds = ['SOURCE', 'PRIORITY', 'SENTIMENT', 'DISPLAYDATE'];

    getComponentType(componentType: string): Type<any> {
        return this._map[componentType];
    }

    getInitializer(componentType: string, property: any, subject?: Subject<TemplateControlValue> | ReplaySubject<TemplateControlValue>): (ref: ComponentRef<any>, value: any) => void {
        // console.log(property);
        const configBase = this._generateConfig(componentType, property);
        return (ref: ComponentRef<any>, value?: any) => {
            ref.instance.config = this._setDefaultValue(componentType, configBase, value);
            ref = this._setUIConfig(componentType, ref);
            ref = this._setSubject(componentType, ref, subject);
        };
    }

    private _generateConfig(componentType: string, property: any): any {
        let config: TemplateControlConfig = new TemplateControlConfig();
        config = Object.assign(config, property);
        config.isRequired = this.mapIsRequiredServer2UX(config);
        config.isLabelHidden = false;
        config.noteAction = NoteActions.createNote;
        if (this._map[componentType] === MultiEntityDropdownComponent) {
            config.prefixId = '';
        }
        return config;
    }

    mapIsRequiredServer2UX(config: TemplateControlConfig) {
        return !this._defaultRequiredControlIds.find(controlId => controlId === config.controlID) && config.isRequired;
    }

    private _setUIConfig(componentType: string, ref: ComponentRef<any>) {
        // ref.instance.config.width = ref.location.nativeElement.parentElement.offsetWidth;
        // ref.instance.config.controlWidth = 0.7 * ref.location.nativeElement.parentElement.offsetWidth - 0.5;
        // ref.instance.config.labelWidth = 0.3 * ref.location.nativeElement.parentElement.offsetWidth;
        // if (componentType === 'ckeditor-input' || componentType === 'nb-input') {
        //     ref.instance.config.inlineMode = true;
        // }
        return ref;
    }

    private _setDefaultValue(componentType: string, config: any, value: any): any {
        // switch (componentType) {
        //     case 'nb-input': break;
        //     default: break;
        // }
        // if (['entity-input', 'met-input', 'med-input'].includes(componentType)) {
        //     config.defaultValue = value;
        // } else {
        if (value !== undefined) {
            config.staticDefaultValue = value;
            config.defaultValue = null;
        }
        // }
        return config;
    }

    private _setSubject(componentType: string, ref: ComponentRef<any>, subject?: Subject<TemplateControlValue> | ReplaySubject<TemplateControlValue>): ComponentRef<any> {
        switch (componentType) {
            case 'nb-input':
            case 'ckeditor-input':
                ref.instance.valueChangeSubject = subject;
                ref.instance.noteBodySubject = new Subject<any>();
                break;
            case '':
                break;
            default:
                ref.instance.valueChangeSubject = subject; break;
        }
        return ref;
    }

}
